import { httpClientFunction } from 'domain/types';
import { UpdateDashboardFrameClient } from 'use-case/dashboard/update/updateDashboardClient';

import { UpdateDashboardFrameCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardFrameCriteria';
import { asDashboard } from 'adapter/out/client/dashboard/mappers/dashboard';

import { right, left } from 'fp-ts/lib/Either';
import { UpdateDashboardResult } from 'use-case/dashboard/update/updateDashboardUseCase';

export default (httpClient: httpClientFunction, baseUrl: string): UpdateDashboardFrameClient => async (
    criteria: UpdateDashboardFrameCriteria
): Promise<UpdateDashboardResult> => {
    try {
        const response = await httpClient(`${baseUrl}/dashboards/dashboards/${criteria.id}`, {
            method: 'PATCH',
            body: JSON.stringify(asDashboardJson(criteria)),
            headers: { 'Content-Type': 'application/json' },
        });

        if (!response.ok) {
            return left({ error: new Error(), status: response.status });
        }

        const json = await response.json();
        const dashboardJson = Array.isArray(json) ? json[0] : json;

        return right(asDashboard(dashboardJson));
    } catch {
        return left({ error: new Error(), status: 503 });
    }
};

export const asDashboardJson = (criteria: UpdateDashboardFrameCriteria): DashboardUpdateFrameJsonRequest => ({
    frame: {
        header: {
            logo: criteria.frame.header.logo,
            template_name: criteria.frame.header.templateName,
            period: criteria.frame.header.period,
            location: criteria.frame.header.location,
        },
        footer: {
            generation_date: criteria.frame.footer.generationDate,
            page_number: criteria.frame.footer.pageNumber,
        },
    },
});

export type DashboardUpdateFrameJsonRequest = {
    frame: {
        header: {
            logo: boolean;
            ['template_name']: boolean;
            period: boolean;
            location: boolean;
        };
        footer: {
            ['generation_date']: boolean;
            ['page_number']: boolean;
        };
    };
};
